// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-notification-wrapper .notification-message[data-v-1a0a5cc3] {\n  word-break: break-word;\n}", ""]);
// Exports
module.exports = exports;
